export default "__VITE_PUBLIC_ASSET__01a5278c__"